import { tryGetAttributeValue } from "api/helpers/tryGetAttributeValue";
import { SiteSurvey } from "api/types/siteSurvey";
import { SiteSurveyConfiguration } from "api/types/siteSurveyConfiguration";

export function UnitsTable({ config, units }: { config: SiteSurveyConfiguration; units: SiteSurvey["units"] }) {
  return (
    <table className="mt-3 table table-sm table-striped">
      <thead className="table-light">
        <tr className="align-middle" style={{ fontSize: "x-small" }}>
          <th scope="col">Unit</th>
          <th scope="col">Manufacturer</th>
          <th scope="col">Model Number</th>
          <th scope="col">Serial Number</th>
          <th scope="col" style={{ width: "3rem" }}>
            Year Built
          </th>
          <th scope="col">Age</th>
          <th scope="col">Tonnage</th>
          <th scope="col" style={{ width: "3rem" }}>
            Type of heat
          </th>
          <th scope="col">Voltage</th>
          <th scope="col">MOCP</th>
          <th scope="col">
            Amperage<div>At Breaker Panel</div>
          </th>
          <th scope="col" style={{ width: "5rem" }}>
            Wire Size
          </th>
          <th scope="col">Curb Type</th>
        </tr>
      </thead>
      <tbody>
        {units.map((unit, index) => {
          const getAttVal = (name: string) =>
            tryGetAttributeValue(config.unitConfiguration.attributes, unit.attributes, name);
          return (
            <tr key={`unitTable-${index}-${unit.id}`}>
              <td>RTU {unit.rtu}</td>
              <td>{getAttVal("Manufacturer")}</td>
              <td>{unit.modelNumber}</td>
              <td>{unit.serialNumber}</td>
              <td>{getAttVal("Year Built")}</td>
              <td>{getAttVal("Age")}</td>
              <td>{getAttVal("Tonnage")}</td>
              <td>{getAttVal("Heat Present")}</td>
              <td>{getAttVal("Unit Voltage")}</td>
              <td>{getAttVal("Breaker/Fuse Size")}</td>
              <td>{getAttVal("Breaker Panel Amperage")}</td>
              <td>{getAttVal("Wire Size From Panel To Unit")}</td>
              <td>{getAttVal("Are units on existing curbs or curb adapters?")}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
